<template>
    <div class="reservas mt-1">
        <div class="row p-2">
            <div class="col-sm-2">
                <b-form-select v-model="bAno" :options="cbAno" size="md" @change="leemos"></b-form-select>
            </div>
            <div class="col-sm-2">
                <b-form-select v-model="bStd" :options="cbStd" size="md" @change="filtro"></b-form-select>
            </div>
            <div class="col-sm-4">
                <b-input-group>
                    <b-input-group-prepend is-text>
                        <b-icon-search/>
                    </b-input-group-prepend>
                    <b-form-input v-model="bTxt"
                        @keypress.13="filtro"
                        @click:append="filtro">
                    </b-form-input>
                </b-input-group>
            </div>
            <div class="col-sm-1">{{ rows }}</div>
        </div>
        <b-table striped hover bordered small
            id="tablaReservas"
            sticky-header="400px" head-variant="light"
            :items="reservas" :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            selectable select-mode="single"
            @row-selected="selecciona_reserva" @row-dblclicked="selecciona"
            class="table-responsive-md bg-white" responsive="sm">

            <template #cell(icono)="{ item }">
                <p class="h4 mb-1">
                    <b-icon
                        v-b-tooltip.right.hover :title="iconoStd(item.std).name"
                        :icon="iconoStd(item.std).icon"
                        :variant="iconoStd(item.std).color">>
                    </b-icon>
                </p>
            </template>

            <template #cell(id)="{ item }">
                <div :class="'text-center font-weight-bold'+(item.std>3 ? ' text-danger' : ' text-dark')">
                    {{ item.id }}
                </div>
            </template>

            <!-- <template slot="cell(hotel)" slot-scope="{item: { hotel }}"> -->
            <template slot="cell(hotel)" slot-scope="{item}">
                <div :class="(item.std>3 ? 'text-danger font-italic' : 'text-dark font-weight-bold')">
                <!-- <div :class="'text-'+iconoStd(item.std).color"> -->
                    {{ item.hotel }}
                    <br><small>{{ item.agencia }}</small>
                </div>
            </template>

            <template slot="cell(n1)" slot-scope="{item}">
                {{ item.n1 }}
                <br>
                <small>{{ item.n2 }}</small>

            </template>


            <template #cell(action)="{ item }">
                <b-btn size="sm" variant="light" class="p-1"
                    v-b-tooltip.hover title="Ver Reserva"
                    @click="selecciona(item)"
                    ><b-icon icon="search"></b-icon>
                </b-btn>
            </template>

        ></b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="tablaReservas"
        ></b-pagination>
    </div>
</template>

<script>

    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        name: 'listaReservas',
        components: {
        },
        data() {
            return {
                fields: [
                    { key: 'icono', label:'' },
                    { key: 'id', label: 'Reserva', sortable: true },
                    { key: 'hotel', label: 'Hotel' },
                    { key: 'n1', label: 'Cliente' },
                    { key: 'fhe', label: 'Entrada' },
                    // { key: 'n1', label: 'Cliente'},
                    { key: 'pax', label: 'Pax' },
                    { key: 'tot', label: 'Importe'},
                    { key: 'action', label:'' }
                ],
                reservas: [],
                perPage: 100,
                currentPage: 1,
                selected: [],
                ref: false,

                bAno: '',
                bStd: '0',
                bTxt: '',

                itemsRes: [],
                itemsAno: [],
                itemsStd:[
                    {value:'0', text:'(Estado)'},
                    {value:'1', text:'PENDIENTE'},
                    {value:'2', text:'CONFIRMADA'},
                    {value:'3', text:'FACTURADA'},
                    {value:'4', text:'ANULADA'},
                    {value:'5', text:'CANCELADA'},
                ],

                estados:[
                    {id:0, name:'*', icon: "arrow-up-circle", color: "info"},
                    {id:1, name:'PENDIENTE', icon: "lock-fill", color: "dark"},
                    {id:2, name:'CONFIRMADA', icon: "unlock-fill",   color: "warning"},
                    {id:3, name:'FACTURADA', icon: "check-circle-fill", color: "success"},
                    {id:4, name:'ANULADA', icon: "x-circle-fill", color: "danger"},
                    {id:5, name:'CANCELADA', icon: "x-circle-fill", color: "danger"},
                ],

            }
        },
        computed: {
            ...mapState(['auth']),

            rows() {
                return this.reservas.length;
            },

            cbAno() {
                let result=this.$util.object_array(this.itemsAno);
                var A=[]; //[{text:"Selecciona Transporte", value:null, disabled:false}];
                result.forEach(value => {
                    //let txt=(value=='*SIN TRANSPORTE'?'En mi vehiculo (Sin Bus)':"BUS - "+value);
                    A.push({text:value.name, value:value.id, disabled:false});
                });
                return A;
            },

            cbStd() {
                return this.itemsStd;
            }

        },
        mounted() {
            //this.leemosReservas();
            this.ref="hola";
            this.leemos();

        },
        methods: {
            ...mapMutations(['loading','alerta','modal']),
            ...mapActions(['exec','error']),

            async leemos() {
                this.loading();
                //var args={ token: this.auth.token }
                var args={ sid: this.auth.token, ano: this.bAno };
                let r=await this.exec({api:'reservas', arg: args });
                this.loading(false);

                if (await this.error({r})) r.datos=[[],[]];

                // guardamos datos (Reservas, Años)
                this.itemsRes=Object.values(r.datos[0]);
                this.itemsAno=Object.values(r.datos[1]);
                //this.itemsDep=Object.values(r.datos[2]);

                if (!this.bAno) this.bAno=this.itemsAno[0].id;
                //this.bDep='0';
                this.bStd='0';
                this.bTxt='';

                this.filtro();
            },

            filtro() {
                var R=this.itemsRes.slice();
                var RR=R;
                let t=this.bTxt.toLowerCase();
                let s=Number(this.bStd);

                console.log('*filtro',t,s,R);

                if (t!='') RR=R.filter(e => {
                    return (
                        e.id.toLowerCase().includes(t)
                        ||e.n1.toLowerCase().includes(t)
                        ||e.n2.toLowerCase().includes(t)
                        ||e.hotel.toLowerCase().includes(t)
                        ||e.agencia.toLowerCase().includes(t)

                    );
                });

                //if (d!='0') EE=E.filter(e => { return (d==e.dep) } );
                if (s!='0') RR=R.filter(e => { return (s==Number(e.std)) } );

                this.reservas=RR;
            },

            // seleccion de reserva (ver)
            selecciona(item) {
                this.selecciona_reserva(item);
                this.$store.state.reserva=item;
            },
            selecciona_reserva(item) {
                this.selected = item;
                //console.log("* listaReservas.selecciona_reserva",item);
            },

            iconoStd(std) {
                return this.estados[std];
            }
        }
    }
</script>